<template>
  <b-modal
    id="modal-prevent-closing"
    ref="modal"
    v-model="showModal"
    hide-footer
    centered
    noCloseOnBackdrop
  >
  <template #modal-title> Create partner </template>
    <validation-observer ref="addUserForm" >
      <b-form class="auth-add-user-form my-2" @submit.prevent="addUser">
        <b-form-group label="full name" label-for="add-user-fullName">
          <validation-provider
            #default="{ errors }"
            name="fullName"
            vid="fullName"
            rules="required"
          >
            <b-form-input
              autocomplete="on"
              id="add-user-fullName"
              v-model="fullName"
              name="add-user-fullName"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- email -->
        <b-form-group label="email" label-for="add-user-email">
          <validation-provider
            #default="{ errors }"
            name="Email"
            vid="email"
            rules="required|email"
          >
            <b-form-input
              autocomplete="on"
              id="add-user-email"
              v-model="userEmail"
              name="add-user-email"
              :state="errors.length > 0 ? false : null"
              placeholder="admin@example.com"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-button
          block
          type="submit"
          class="my-1 gradient-btn"
        >
          Create partner
        </b-button>
      </b-form>
    </validation-observer>
    <loader :loading="loading" />
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BCardText,
  BModal,
} from "bootstrap-vue";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@/@core/components/loader/Loader.vue";

export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BModal,
    Loader,
  },
  data() {
    return {
      fullName: "",
      userEmail: "",
      loading: false,
      required,
    };
  },
  computed: {
    showModal: {
      set(newVal) {
        this.$emit("input", newVal);
      },
      get() {
        return this.visible;
      },
    },
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    addUser() {
      this.$refs.addUserForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            const { data } = await this.$http.post("/panel/partners", {
              name: this.fullName,
              email: this.userEmail,
            });
            this.$emit("updateUsers");
          } catch (err) {}
          this.loading = false;
          this.showModal = false;
        }
      });
    },
  },
};
</script>
